/**
 * Handle password field
 */
export default {
  methods: {
    /**
     * @vuese
     * Initiate password field for password visualization toggle and password rules div toggle
     */
    initPasswordField(inputObj) {
      if (this.inputs.find((input) => input.name === inputObj.name)) {
        return null
      }
      inputObj.el = this.form.find(`[name="${inputObj.name}"]`)
      inputObj.toggle = this.form.find(`.password-toggle[data-for="${inputObj.id}"]`)
      inputObj.toggle.on('click keypress', (e) => {
        e.preventDefault()
        const inputType = inputObj.el.attr('type')
        if (e.type === 'click') {
          if (inputType === 'password') {
            inputObj.el.attr('type', 'text')
          } else {
            inputObj.el.attr('type', 'password')
          }
          $(e.target).toggleClass(['fa-eye', 'fa-eye-slash'])
         
          $(e.target).attr('aria-checked', function(_, attr){
            return attr == 'false' ? 'true' : 'false';
          });
        } else if (e.type === 'keydown' || e.type === 'keypress') {
          if((e.code === 'Enter')|| (e.code === 'Space')) {
            if (inputType === 'password') {
              inputObj.el.attr('type', 'text')
            } else {
              inputObj.el.attr('type', 'password')
            }
            $(e.target).toggleClass(['fa-eye', 'fa-eye-slash'])
            $(e.target).attr('aria-checked', function(_, attr){
              return attr == 'false' ? 'true' : 'false';
            });
          }
        }

      })
      const hasPasswordValidation = inputObj.el.data('passwordValidation')
      if (hasPasswordValidation) {
        const passwordRules = inputObj.el.parent().find('.password-rules')
        inputObj.el.on('focus', (e) => {
          passwordRules.addClass('active')
        })
        inputObj.el.on('blur', (e) => {
          passwordRules.removeClass('active')
        })
      }
      return inputObj
    },
  },
}
